
import { DisenioPaginas } from "../../layout";
import { FormCreateUpdateLote } from "../../components";





export const CrearLotes = () => {

    const initialState = {
        granja: '',
        encubadora: '',
        cantidadTotal: '',
        factura: '',
        machos: '',
        hembras: '',
    }
    


    return (

        <DisenioPaginas titulo="Crear Lote" url={1} add={false} subtitulo="Información del lote">
            <FormCreateUpdateLote initialState={initialState} />
        </DisenioPaginas>
    )
}
